import React, { useState, FunctionComponent, useEffect } from 'react';
import {
  Dimensions, StyleSheet, View, ScrollView,
  NativeSyntheticEvent, NativeScrollEvent,
  ViewStyle,
} from "react-native";
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const { width } = Dimensions.get('window');

interface IProps {
  children: React.ReactNode;
  containerStyle: ViewStyle;
  fixedContent?: JSX.Element;
}

export const Slider: FunctionComponent<IProps> = ({ children, containerStyle, fixedContent}) => {
  const [page, setPage] = useState<number>(0);
  const [slideCount, setSlideCount] = useState<number>(0);

  useEffect(() => {
    const slideCount = React.Children.count(children);
    setSlideCount(slideCount);
  }, []);

  const setSliderPage = (event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const { x } = event.nativeEvent.contentOffset;
    const indexOfNextScreen = Math.round(x / width);
    if (indexOfNextScreen !== page) {
      setPage(indexOfNextScreen);
    }
  }

  return (
    <View style={[styles.container, containerStyle]}>
      <ScrollView
        horizontal={true}
        scrollEventThrottle={16}
        pagingEnabled={true}
        snapToAlignment={'start'}
        showsHorizontalScrollIndicator={false}
        onScroll={setSliderPage}
        style={styles.scrollViewContainer}>
        {children}
      </ScrollView>
      {fixedContent}
      <View style={styles.paginationDotsContainer} >
        {Array.from(Array(slideCount)).map((_, index) => (
          <View
            key={index}
            style={[styles.paginationDots, {
              opacity: page === index ? 1 : 0.2,
              marginLeft: index > 0 ? defaultScale(18) : 0 }]}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '100%'
  },
  scrollViewContainer: {
    flex: 1,
    width,
    height: '100%',
  },
  paginationDotsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingHorizontal: defaultScale(30),
  },
  paginationDots: {
    height: defaultScale(9),
    width: defaultScale(9),
    borderRadius: defaultScale(10 / 2),
    backgroundColor: Theme.BLACK,
  },
});
